import React from 'react';
import {ScrollView, TouchableOpacity} from 'react-native';

import ContentView from '../../components/ui-controls/layout/ContentView';
import Markdown from '../../components/ui-controls/Markdown';
import Text from '../../components/ui-controls/Text';
import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

// Don't format on save!
// This will live in Airtable:
//  1862-Content configuration in Airtable (T&Cs, etc.)
//  https://dev.azure.com/lmgdevops/branded_website/_workitems/edit/1862

const copy = `
# Step 1: Discover our range

Congratulations on receiving a gift that keeps on giving! Begin by exploring our range of Wine, Beer, Spirits and Premixed drinks at [www.${config.HOST_DOMAIN}](http://${config.HOST_DOMAIN}).

# Step 2: Fill your cart

Once you've wandered through our extensive range and found your favourite drinks, simply add them to your shopping cart.

# Step 3: Check Out

When your cart is brimming with your chosen favourites, proceed to the checkout page. Here, you'll find an option to redeem your gift card. Enter the card number and the unique PIN code provided and watch the magic unfold as your gift card balance is applied to your order total.

# Step 4: Sip Back and Relax

After successfully redeeming your gift card, take a moment to revel in the anticipation of the delights that will soon be in your possession. If you chose the delivery option, we will arrive at your desired time.  If you chose to pick up, what are you waiting for, get on down to your local Harry Brown store and grab your goodies!

# Step 5: Share the Joy

Whether it's a virtual toast with friends or a cosy night in, your gift card is a token of joy meant to be shared. Snap a photo, tag us on social media, and let the world know about your liquid treasure. After all, the best spirits are those enjoyed in good company.
`;

const GiftCardsHowToRedeemScreen = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_HOW_TO_REDEEM>) => (
  <ContentView>
    <ScrollView>
      <Markdown>{copy}</Markdown>
      <Text>
        Note:{' '}
        <TouchableOpacity
          onPress={() =>
            navigation.navigate(AppRoute.GIFT_CARDS_TERMS_AND_CONDITIONS)
          }>
          <Text style={{color: 'blue'}}>Terms and Conditions</Text>
        </TouchableOpacity>{' '}
        apply
      </Text>
      <Text>
        {'\n'}
        Please review our terms and conditions for gift card usage to ensure a
        seamless redemption experience. If you encounter any issues, our
        dedicated customer support team is just a click away, ready to assist
        you in raising your spirits.
      </Text>
    </ScrollView>
  </ContentView>
);

export default GiftCardsHowToRedeemScreen;
